/**
 * Origen clínica para metadatos del catálogo local (edge_id + nombre).
 */
import { parseEdgeIdFromSearchParams } from '../plan/parsePlanQuery'
import { pickControllerLink } from '../plan/entitlements'

/**
 * @param {URLSearchParams|null|undefined} params
 * @returns {string|null}
 */
export function parseClinicNameFromSearchParams(params) {
  if (!params || typeof params.get !== 'function') return null
  const raw = params.get('clinic_name')
  if (raw == null || String(raw).trim() === '') return null
  return String(raw).trim()
}

/**
 * @param {{
 *   searchParams?: URLSearchParams|null,
 *   ticket?: object|null,
 *   controllerLinks?: object[]|null,
 * }} [opts]
 * @returns {{ edgeId: string|null, clinicName: string|null }}
 */
export function resolveStudyCatalogOrigin(opts = {}) {
  const params = opts.searchParams || null
  const ticket = opts.ticket || null
  const links = opts.controllerLinks || null
  const raw = ticket && ticket.raw && typeof ticket.raw === 'object' ? ticket.raw : {}

  let edgeId = parseEdgeIdFromSearchParams(params)
  if (!edgeId) {
    edgeId =
      (ticket && ticket.edgeId) ||
      raw.edge_id ||
      raw.edgeId ||
      null
  }
  if (edgeId != null && String(edgeId).trim() !== '') {
    edgeId = String(edgeId).trim()
  } else {
    edgeId = null
  }

  let clinicName = parseClinicNameFromSearchParams(params)
  if (!clinicName) {
    clinicName =
      raw.clinic_name ||
      raw.clinicName ||
      (ticket && ticket.clinicName) ||
      null
  }
  if (!clinicName && edgeId && Array.isArray(links) && links.length) {
    const link = pickControllerLink(links, edgeId, { exactOnly: true })
    if (link) {
      clinicName = link.clinic_name || link.clinicName || null
    }
  }
  if (clinicName != null && String(clinicName).trim() !== '') {
    clinicName = String(clinicName).trim()
  } else {
    clinicName = null
  }

  return { edgeId, clinicName }
}
